// extracted by mini-css-extract-plugin
module.exports = {"boxHeight":"ServiceProvider_boxHeight__481Y2"};